import {
  FETCH_CLIENTS_INDUSTRIES_REQUEST,
  FETCH_CLIENTS_INDUSTRIES_SUCCESS,
  FETCH_CLIENTS_INDUSTRIES_FAILURE,
} from "../actions/fetchClientIndustriesCompetitorsActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default function fetchClientIndustriesCompetitorsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case FETCH_CLIENTS_INDUSTRIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CLIENTS_INDUSTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case FETCH_CLIENTS_INDUSTRIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
